function updateHeaderChroxelOffset() {
  var wrapper = document.querySelector('.header-chroxel-wrapper');
  if (!wrapper) return;
  var rect = wrapper.getBoundingClientRect();
  var offset = Math.max(0, Math.round(rect.bottom));
  document.documentElement.style.setProperty('--header-chroxel-offset', offset + 'px');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateHeaderChroxelOffset);
} else {
  updateHeaderChroxelOffset();
}

window.addEventListener('load', updateHeaderChroxelOffset);
window.addEventListener('resize', updateHeaderChroxelOffset);
window.addEventListener('scroll', updateHeaderChroxelOffset, { passive: true });

function initHeaderChroxelMega() {
  var items = document.querySelectorAll('.header-chroxel__nav-item.has-mega');
  items.forEach(function (item) {
    var mega = item.querySelector(':scope > .header-chroxel__mega');
    if (!mega) return;
    var closeTimer = null;

    function open() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      mega.style.setProperty('display', 'block', 'important');
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        mega.style.removeProperty('display');
        closeTimer = null;
      }, 150);
    }

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);
    mega.addEventListener('mouseenter', open);
    mega.addEventListener('mouseleave', scheduleClose);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderChroxelMega);
} else {
  initHeaderChroxelMega();
}
